<div *ngIf="!errorMessage">
	<div *ngIf="getTableSize()">
		<div [breakpoint]="breakPoint" large-device>
			<div [ngSwitch]="tableType">
				<div *ngSwitchCase="NEW_TABLE">
					<div class="custom-table table-borderless-top">
						<div>
							<nz-table #basicTable [nzData]="tableRows" [nzScroll]="{ x: '1120px' }"
								[nzShowPagination]="false" nzAlign="center" nzTableLayout="fixed">
								<thead>
									<tr class="table-title cap-text">
										<th *ngFor="let header of tableRows[0]?.columns">
											<div *ngIf="header?.canShow">
												{{ header?.title|titlecase}}
											</div>
										</th>
										<th *ngIf="canViewDetails" class="row-icon-space"></th>
									</tr>
								</thead>
								<tbody>
									<tr (click)="emitRowClicked.emit(rows?.objToEmit)" *ngFor="let rows of tableRows"
										class="{{ canViewDetails ? 'addCursor' : '' }}">
										<td *ngFor="let column of rows?.columns;let index = index">
											<ng-container *ngIf="!column?.isSymbol">
												<ng-container *ngIf="!column?.specialColumn">
													<div class="table-value {{column?.columnClass || ''}}"
														[nzTooltipTitle]="column?.value" nzTooltipPlacement="bottom"
														nz-tooltip nzTooltipOverlayClassName="custom-tooltip-col"
														[nzTooltipColor]="'white'"
														[nzTooltipTrigger]="column?.value?.length > 25 ? 'hover':null">
														<div *ngIf="column?.truncate" [title]="column?.value">
															{{column?.value | truncate:column?.truncate}}
														</div>
														<div *ngIf="!column?.truncate">
															{{column?.value | truncate:column?.truncate}}
														</div>
													</div>
												</ng-container>
												<ng-container *ngIf="column?.specialColumn">
													<div class="table-value  {{column?.columnClass || ''}}">
														<app-moniepoint-table-special-column [rateProcess]="rows.rating"
															[isMobile]="isMobile" [columnType]="column?.columnType"
															[columnValue]="column?.value"
															[dateFormat]="column?.dateFormat">
														</app-moniepoint-table-special-column>
													</div>
												</ng-container>
											</ng-container>
											<ng-container *ngIf="column?.isSymbol">
												<div class="{{column?.symbolClass}} text-right">
													<ng-container *ngIf="!column?.labelSymbol && !rows?.actionClass">
														<app-grey-icon [greyIcon]="column?.greyIcon || 'grey-table-details-icon'">
														</app-grey-icon>
													</ng-container>
													<ng-container *ngIf="column?.labelSymbol">
														{{column?.labelSymbol}}
													</ng-container>
												</div>
											</ng-container>
										</td>
									</tr>
								</tbody>
							</nz-table>
							<div *ngIf="showPagination" class="m-t-10">
								<div class="vertical-flex j-c-center">
									<pagination (currentPageEvent)="setChangePage($event)"
										[basicPagination]="basicPagination" [currentPageNo]="pageNumber" [pageLimit]="5"
										[totalItemNo]="totalItems" [totalPage]="totalPages">
									</pagination>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="custom-table table-borderless-top" *ngSwitchCase="OLD_TABLE">
					<div>
						<nz-table #basicTable [nzData]="rows" [nzScroll]="{ x: '1120px' }" [nzShowPagination]="false"
							nzAlign="center" nzTableLayout="fixed">
							<thead>
								<tr class="table-title cap-text">
									<th *ngFor="let header of headers">
										<div *ngIf="header !== KEY">
											{{ header }}
										</div>
									</th>
									<th *ngIf="canViewDetails" class="row-icon-space"></th>
								</tr>
							</thead>
							<tbody>
								<tr (click)="rowClicked(row)" *ngFor="let row of rows"
									class="{{ canViewDetails ? 'addCursor' : '' }}">
									<td *ngFor="
                                        let column of convertObjToArr(row);
                                        let index = index
                                    ">
										<ng-container *ngIf="headers[index] !== KEY">
											<ng-container *ngIf="
                                                !isSpecialColumn(headers[index])
                                            " class="table-value">
												<ng-container *ngIf="column">
													{{ column }}
												</ng-container>
											</ng-container>
											<ng-container *ngIf="
                                                isSpecialColumn(headers[index])
                                            " class="table-value">
												<app-moniepoint-table-special-column [columnType]="
                                                    getSpecialColumnType(
                                                        headers[index]
                                                    )
                                                " [columnValue]="column">
												</app-moniepoint-table-special-column>
											</ng-container>
										</ng-container>
										<ng-container *ngIf="headers[index] === KEY">
											<div class="{{
                                                row[KEY]?.labelClass
                                            }} text-right">
												<ng-container *ngIf="
                                                    row[KEY]?.keyLabel ===
                                                    'ICON'
                                                ">
													<app-grey-icon greyIcon="grey-table-details-icon">
													</app-grey-icon>
												</ng-container>
												<ng-container *ngIf="
                                                    row[KEY]?.keyLabel !==
                                                    'ICON'
                                                ">
													{{ row[KEY]?.keyLabel }}
												</ng-container>
											</div>
										</ng-container>
									</td>
								</tr>
							</tbody>
						</nz-table>
						<div *ngIf="showPagination" class="m-t-10">
							<div class="vertical-flex j-c-center">
								<pagination (currentPageEvent)="setChangePage($event)"
									[basicPagination]="basicPagination" [currentPageNo]="pageNumber" [pageLimit]="5"
									[totalItemNo]="totalItems" [totalPage]="totalPages">
								</pagination>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div [breakpoint]="breakPoint" mobile-device>
			<div [ngSwitch]="mobileTableType">

				<div *ngSwitchCase="REFINED_DEVICE">
					<div (click)="emitRowClicked.emit(rows?.objToEmit)" *ngFor="let rows of tableRows"
						class="mobile-device-table-container {{rows.coloredRow?rows.rowColorClass:''}}">
						<div>
							<div class="mobile-device-table-title">
								<span *ngIf="!rows?.specialMobileTitle">
									{{rows?.manufacturer}}
								</span>
								<app-moniepoint-table-special-column *ngIf="rows?.specialMobileTitle"
									[isMobile]="isMobile" [columnType]="rows?.mobileTitleType"
									[columnValue]="rows.manufacturer">
								</app-moniepoint-table-special-column>
							</div>
							<div>
								<div nz-row nzAlign="middle">
									<div *ngFor="let column of rows?.columns"
										class="{{column?.columnSpan === 24?'m-t-4':''}} {{column?.hideOnMobile?'display-none':'display-block '}}"
										nz-col nzSpan="{{column?.columnSpan || COL_12}}">
										<div class="m-t-16">
											<div class="mobile-device-table-label">
												{{column?.title|titlecase}}
											</div>
											<div class="m-t-4">
												<div class="mobile-device-table-label-value">
													<div *ngIf="!column?.specialColumn">
														{{column?.value}}
													</div>
													<div *ngIf="column?.specialColumn">
														<app-moniepoint-table-special-column [isMobile]="isMobile"
															[columnType]="column?.columnType"
															[columnValue]="column?.value">
														</app-moniepoint-table-special-column>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div *ngIf="rows?.actionName">
									<div class="m-t-24">
										<div class="mobile-device-table-divider"></div>
									</div>
								</div>
								<div *ngIf="!(rows?.hideDetailsBtn)" class="m-t-24 text-center">
									<div class="{{rows?.actionClass}}">
										{{rows?.actionName}}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div *ngSwitchCase="REFINED_DEVICE_V2">
					<div (click)="emitRowClicked.emit(rows?.objToEmit)" *ngFor="let rows of tableRows"
						class="mobile-device-table-container {{rows.coloredRow?rows.rowColorClass:''}}">
						<div nz-row nzAlign="middle">
							<div nz-col nzSpan="4">
								<span
									*ngIf="rows?.objToEmit?.manufacturer?.toLowerCase() =='ios' || rows?.objToEmit?.manufacturer?.toLowerCase() =='mac os' else other">
									<app-grey-icon greyIcon="grey-ios"></app-grey-icon>
								</span>
								<ng-template #other>
									<app-grey-icon greyIcon="grey-android"></app-grey-icon>
								</ng-template>
							</div>
							<div class="flex items-center" nz-col nzSpan="18">
								<div nz-col nzSpan="10">
									<div>{{ rows?.objToEmit?.model | titlecase}}</div>
									<div>{{ rows?.objToEmit?.manufacturer | uppercase}}</div>
								</div>
								<div nz-col nzSpan="14">
									<span [class]="'tag-'+ rows?.objToEmit?.state?.toLowerCase()">
										{{rows?.objToEmit?.state |removeUnderscore|uppercase|truncate:15}}
									</span>
									<div> {{rows?.objToEmit?.createdOn | date }}</div>
								</div>
							</div>
							<div nz-col nzSpan="2" *ngIf="rows?.objToEmit?.state === 'ACTIVATED'">
								<svg width="12" height="16" viewBox="0 0 16 18" fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<path fill-rule="evenodd" clip-rule="evenodd"
										d="M6.90005 0.203125C6.4834 0.203125 6.10251 0.438528 5.91618 0.81119L5.12021 2.40313H1.40005C0.792536 2.40313 0.300049 2.89561 0.300049 3.50313C0.300049 4.11064 0.792536 4.60313 1.40005 4.60313L1.40005 15.6031C1.40005 16.8182 2.38502 17.8031 3.60005 17.8031H12.4C13.6151 17.8031 14.6 16.8182 14.6 15.6031V4.60313C15.2076 4.60313 15.7 4.11064 15.7 3.50313C15.7 2.89561 15.2076 2.40313 14.6 2.40313H10.8799L10.0839 0.81119C9.89759 0.438528 9.5167 0.203125 9.10005 0.203125H6.90005ZM4.70005 6.80313C4.70005 6.19561 5.19254 5.70312 5.80005 5.70312C6.40756 5.70312 6.90005 6.19561 6.90005 6.80313V13.4031C6.90005 14.0106 6.40756 14.5031 5.80005 14.5031C5.19254 14.5031 4.70005 14.0106 4.70005 13.4031V6.80313ZM10.2 5.70312C9.59254 5.70312 9.10005 6.19561 9.10005 6.80313V13.4031C9.10005 14.0106 9.59254 14.5031 10.2 14.5031C10.8076 14.5031 11.3 14.0106 11.3 13.4031V6.80313C11.3 6.19561 10.8076 5.70312 10.2 5.70312Z"
										fill="#E94444" />
								</svg>

							</div>
						</div>

					</div>
				</div>

				<div *ngSwitchCase="REFINED_POS">
					<div (click)="emitRowClicked.emit(rows?.objToEmit)" *ngFor="let rows of tableRows" class="mobile-table-card {{
           canViewDetails ? 'addCursor' : ''}}">
						<div>
							<div nz-row nzAlign="middle" nzJustify="space-between">
								<div>
									<div class="mobile-table-title">
										<app-moniepoint-table-special-column [columnType]="rows?.posTitleType || ''"
											[columnValue]="rows?.posTitle">
										</app-moniepoint-table-special-column>
									</div>
								</div>
								<div>
									<span [class]="'tag-' + rows?.posStatus?.toLowerCase()">
										{{rows?.posStatus| uppercase| removeUnderscore}}
									</span>
								</div>
							</div>

							<div>
								<div style="margin-top: -3px">
									<div nz-row nzAlign="middle">
										<div *ngFor="let column of rows?.columns;let index = index"
											class="{{column?.hideOnMobile?'display-none':'display-block'}}" nz-col
											nzSpan="{{column?.columnSpan || COL_12}}">
											<div class="m-t-19">
												<div>
													<div class="mobile-table-card-label">
														{{column?.title|titlecase}}
													</div>
													<div class="mobile-table-card-value">
														<div *ngIf="!column?.specialColumn">
															<div>
																{{column?.value}}
															</div>
														</div>
														<div *ngIf="column?.specialColumn">
															<app-moniepoint-table-special-column
																[columnType]="column?.columnType"
																[columnValue]="column?.value">
															</app-moniepoint-table-special-column>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="m-t-16">
								<div class="mobile-device-table-divider"></div>
							</div>
							<div class="text-center">
								<div *ngIf="canViewDetails">
									<div class="mobile-card-view-more">
										<div class="m-t-24 addCursor">
											View More
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div *ngSwitchCase="REFINED_TRANSACTION">
					<div (click)="emitRowClicked.emit(columns?.objToEmit)" *ngFor="let columns of tableRows"
						class="mobile-trans-table-card {{canViewDetails ? 'addCursor' : ''}}">
						<div nz-row nzAlign="middle" nzJustify="space-between">
							<div>
								<div class="mobile-table-title">
									<app-moniepoint-table-special-column columnType="amount"
										[columnValue]="columns?.transactionAmount">
									</app-moniepoint-table-special-column>
								</div>
							</div>
							<div *ngIf="canViewDetails" nz-row nzAlign="middle">
								<ng-container>
									<div class="mobile-trans-table-view-more">
										View More
									</div>
								</ng-container>
								<div style="position: relative; top: 0.2em">
									<!-- <app-icon icon="caret-right"></app-icon> -->
								</div>
							</div>
						</div>
						<ng-container class="m-t-16">
							<div class="mobile-trans-divider"></div>
						</ng-container>
						<div class="m-t-n-16">
							<div [nzGutter]="16" nz-row nzAlign="middle">
								<div *ngFor="let column of columns?.columns; let index = index"
									class="{{column?.hideOnMobile?'display-none':'display-block '}}" nz-col
									[nzSpan]="column?.columnSpan || COL_12">
									<div class="m-t-24">
										<div *ngIf="column?.canShow">
											<div class="mobile-table-card-label">
												{{column?.title|titlecase}}
											</div>
											<div class="mobile-table-card-value-trans">
												<div *ngIf="!column?.specialColumn">
													<div [title]="column?.value" *ngIf="column?.truncate">
														{{column?.value|truncate:column?.truncate}}</div>
													<div *ngIf="!column?.truncate">{{column?.value}}</div>
												</div>
												<ng-container *ngIf="column?.specialColumn">
													<app-moniepoint-table-special-column
														[columnType]="column?.columnType" [columnValue]="column?.value">
													</app-moniepoint-table-special-column>
												</ng-container>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div *ngSwitchCase="REFINED_SUMMARY">
					<div (click)="emitRowClicked.emit(rows?.objToEmit)"
						*ngFor="let rows of tableRows; let index = index" class="addCursor">
						<div nz-row nzAlign="middle" nzJustify="space-between">
							<div class="{{ index ? 'm-t-16' : '' }}">
								<div nz-row nzAlign="middle">
									<div>
										<ng-container *ngIf="rows?.transactionCategory === 'credit'">
											<svg fill="none" height="37" viewBox="0 0 36 37" width="36"
												xmlns="http://www.w3.org/2000/svg">
												<g clip-path="url(#clip0_3073_105002)">
													<circle cx="18" cy="18.1797" fill="#1EB12D" opacity="0.1" r="18" />
													<path
														d="M21.6606 13.8705L15.2432 20.2879L15.2432 14.6806C15.2432 14.2324 14.8755 13.8647 14.4273 13.8647C14.3209 13.8646 14.2155 13.8855 14.1172 13.9262C14.0189 13.9669 13.9295 14.0265 13.8543 14.1018C13.779 14.177 13.7194 14.2664 13.6787 14.3647C13.638 14.463 13.6172 14.5684 13.6173 14.6748L13.6173 22.2471C13.6172 22.3535 13.638 22.4589 13.6787 22.5572C13.7194 22.6555 13.779 22.7449 13.8543 22.8201C13.9295 22.8954 14.0189 22.955 14.1172 22.9957C14.2155 23.0364 14.3209 23.0572 14.4273 23.0571L21.9996 23.0571C22.106 23.0571 22.2113 23.0362 22.3096 22.9955C22.4079 22.9548 22.4972 22.8951 22.5724 22.8199C22.6476 22.7446 22.7073 22.6553 22.748 22.5571C22.7887 22.4588 22.8097 22.3534 22.8097 22.2471C22.8097 22.1407 22.7887 22.0353 22.748 21.9371C22.7073 21.8388 22.6476 21.7495 22.5724 21.6742C22.4972 21.599 22.4079 21.5393 22.3096 21.4986C22.2113 21.4579 22.106 21.437 21.9996 21.437L16.3922 21.437L22.8097 15.0195C23.1256 14.7036 23.1256 14.1865 22.8097 13.8705C22.4937 13.5545 21.9766 13.5545 21.6606 13.8705Z"
														fill="#1EB12D" />
												</g>
												<defs>
													<clipPath id="clip0_3073_105002">
														<rect fill="white" height="36" transform="translate(0 0.179688)"
															width="36" />
													</clipPath>
												</defs>
											</svg>
										</ng-container>

										<ng-container *ngIf="rows?.transactionCategory === 'debit'">
											<svg fill="none" height="37" viewBox="0 0 36 37" width="36"
												xmlns="http://www.w3.org/2000/svg">
												<g clip-path="url(#clip0_3073_105038)">
													<circle cx="18" cy="18.1797" fill="#E94444" opacity="0.1" r="18" />
													<path
														d="M15.0003 22.817L21.4177 16.3996L21.4177 22.0069C21.4177 22.4551 21.7854 22.8228 22.2335 22.8228C22.34 22.8229 22.4453 22.802 22.5437 22.7613C22.642 22.7206 22.7314 22.661 22.8066 22.5857C22.8818 22.5105 22.9415 22.4211 22.9822 22.3228C23.0229 22.2245 23.0437 22.1191 23.0436 22.0127L23.0436 14.4404C23.0437 14.334 23.0229 14.2286 22.9822 14.1303C22.9415 14.032 22.8818 13.9426 22.8066 13.8674C22.7314 13.7921 22.642 13.7325 22.5437 13.6918C22.4453 13.6511 22.34 13.6303 22.2335 13.6304L14.6613 13.6304C14.5549 13.6304 14.4496 13.6513 14.3513 13.692C14.253 13.7327 14.1637 13.7924 14.0885 13.8676C14.0133 13.9429 13.9536 14.0322 13.9129 14.1304C13.8722 14.2287 13.8512 14.3341 13.8512 14.4404C13.8512 14.5468 13.8722 14.6522 13.9129 14.7504C13.9536 14.8487 14.0133 14.938 14.0885 15.0133C14.1637 15.0885 14.253 15.1482 14.3513 15.1889C14.4496 15.2296 14.5549 15.2505 14.6613 15.2505L20.2687 15.2505L13.8512 21.668C13.5352 21.9839 13.5352 22.501 13.8512 22.817C14.1672 23.133 14.6843 23.133 15.0003 22.817Z"
														fill="#E94444" />
												</g>
												<defs>
													<clipPath id="clip0_3073_105038">
														<rect fill="white" height="36" transform="translate(0 0.179688)"
															width="36" />
													</clipPath>
												</defs>
											</svg>
										</ng-container>

									</div>
									<div class="m-l-7">
										<div class="summary-table-title">
											₦ {{rows?.transactionAmount| majorAmount| currency}}
										</div>
										<div class="m-t-4">
											<div class="summary-table-relative-time">
												{{convertToRelativeTime(rows?.relativeDate)}}
											</div>
										</div>
									</div>
								</div>
							</div>
							<div>
								<div>
									<app-moniepoint-table-special-column [columnType]="'trans-type'"
										[columnValue]="rows?.transactionType">
									</app-moniepoint-table-special-column>
								</div>
							</div>
						</div>
						<div class="m-t-14">
							<div class="summary-table-divider"></div>
						</div>
					</div>
				</div>
			</div>
			<div *ngIf="showPagination" class="m-t-10">
				<div class="vertical-flex j-c-center">
					<pagination (currentPageEvent)="setChangePage($event)" [basicPagination]="basicPagination"
						[currentPageNo]="pageNumber" [pageLimit]="3" [totalItemNo]="totalItems"
						[totalPage]="totalPages">
					</pagination>
				</div>
			</div>
		</div>
	</div>
</div>
<div class="m-t-16" *ngIf="errorMessage">
	<div class="p-t-50">
		<app-moniepoint-failure-modal (closeModal)="emitRetryClicked.emit()" [buttonText]="'Retry'"
			[description]="errorMessage" [isTableUse]="true" [title]="'Error Occured'" [useFullButton]="true">
		</app-moniepoint-failure-modal>
	</div>
</div>
<div *ngIf="getTableSize() === 0 && !errorMessage" class="text-center {{
        isMobileEmptyStateCard && isMobile
            ? 'mobile-empty-card'
            : 'web-empty-card'
    }}">
	<div class="m-t-53 flex justify-center items-center">
		<div *ngIf="emptyIcon; else defaultImg">
			<div [ngSwitch]="icon_type">
				<div *ngSwitchCase="'colored'">
					<div [ngSwitch]="emptyIcon">
						<div *ngSwitchCase="'colored-empty-pos-terminal'">
							<svg fill="none" height="132" viewBox="0 0 137 132" width="137"
								xmlns="http://www.w3.org/2000/svg">
								<path
									d="M126 66.1286C126 79.4143 121.551 91.7339 114.096 101.638C110.007 106.952 105.077 111.662 99.4255 115.286C90.2867 121.325 79.3443 124.827 67.5601 124.827C35.2138 124.827 9 98.4975 9 66.1286C9 33.6389 35.2138 7.42969 67.4399 7.42969C79.2241 7.42969 90.1665 10.9323 99.3052 16.8505C104.957 20.4739 109.887 25.1843 113.975 30.4986C121.551 40.4025 126 52.722 126 66.1286Z"
									fill="#F0F6FF" />
								<path
									d="M2.98676 76.582C4.56799 76.582 5.97353 75.3467 5.97353 73.582C5.97353 71.9938 4.74368 70.582 2.98676 70.582C1.22984 70.7585 0 72.1703 0 73.7585C0 75.3467 1.22984 76.582 2.98676 76.582Z"
									fill="#EAEEF9" />
								<path
									d="M134.773 41.5878C136.796 39.691 136.931 36.5748 135.043 34.5425C133.154 32.5102 130.052 32.3747 127.893 34.2716C125.87 36.1684 125.735 39.2846 127.624 41.3168C129.512 43.3491 132.615 43.4846 134.773 41.5878Z"
									fill="#D9E3FF" />
								<path
									d="M131.792 25.0504C132.694 25.0504 133.396 24.3455 133.396 23.4392C133.396 22.533 132.694 21.8281 131.792 21.8281C130.889 21.8281 130.188 22.533 130.188 23.4392C130.188 24.3455 130.889 25.0504 131.792 25.0504Z"
									fill="#D9E3FF" />
								<g filter="url(#filter0_d_3534_264804)">
									<path
										d="M96.4041 59.0859L126.479 89.2944C127.682 90.5028 127.682 92.5167 126.479 93.725L102.219 118.093C101.016 119.302 99.0106 119.302 97.8076 118.093L67.7324 87.8847L96.4041 59.0859Z"
										fill="#082A64" />
								</g>
								<path
									d="M90.3422 65.1033L85.0256 70.4434L117.35 102.911L122.667 97.5711L90.3422 65.1033Z"
									fill="#EAEEF9" fill-opacity="0.4" />
								<path
									d="M102.323 111.001C103.928 109.389 103.928 106.775 102.323 105.163C100.718 103.551 98.1152 103.551 96.51 105.163C94.9049 106.775 94.9049 109.389 96.51 111.001C98.1152 112.614 100.718 112.614 102.323 111.001Z"
									fill="#6278A0" />
								<path
									d="M98.3969 107.113C100.002 105.5 100.002 102.886 98.3969 101.274C96.7917 99.6618 94.1893 99.6618 92.5841 101.274C90.979 102.886 90.979 105.5 92.5841 107.113C94.1893 108.725 96.7917 108.725 98.3969 107.113Z"
									fill="#ABB5CC" />
								<path
									d="M59.9094 23.139L32.0423 51.2278L9.64035 28.7266C9.35869 28.4437 9.52199 27.9683 9.98777 27.9683H11.4915C12.271 27.9683 12.8938 27.3396 12.8938 26.562V23.7426C12.8938 23.5131 13.073 23.3363 13.296 23.3363H16.1031C16.9189 23.3363 17.4712 22.6803 17.5988 21.9112L17.6056 21.8706V21.8294V19.0099C17.6056 18.8041 17.7701 18.5789 18.0636 18.503H20.8148C21.6307 18.503 22.183 17.8469 22.3106 17.0778L22.3173 17.0372V16.996V14.1765C22.3173 13.9901 22.4602 13.7499 22.8649 13.6696H25.6269C26.4427 13.6696 26.995 13.0136 27.1226 12.2445L27.1294 12.2038V12.1626V9.34318C27.1294 9.1481 27.2731 8.93693 27.6319 8.93693H30.4389C31.2547 8.93693 31.807 8.28092 31.9347 7.51183L31.9414 7.47118V7.42998V4.61052C31.9414 4.3811 32.1206 4.20427 32.3437 4.20427H35.1507C35.9665 4.20427 36.5188 3.54826 36.6464 2.77916L36.6532 2.73852V2.69732V1.21115C36.6947 0.816602 36.8823 0.615841 37.035 0.54196C37.1845 0.469676 37.3552 0.484796 37.5031 0.633409L59.9094 23.139Z"
									fill="white" stroke="#E5E9F4" />
								<path
									d="M39.8628 13.0697L36.7551 16.0905C36.4543 16.3926 35.9531 16.3926 35.6523 16.0905C35.3516 15.7884 35.3516 15.285 35.6523 14.9829L38.7601 11.8613C39.0608 11.5592 39.5621 11.5592 39.8628 11.8613C40.1636 12.2641 40.1636 12.7676 39.8628 13.0697Z"
									fill="#C5CCDE" />
								<path
									d="M34.148 18.8088L21.6167 31.295C21.3159 31.5971 20.8146 31.5971 20.5139 31.295C20.2131 30.9929 20.2131 30.4894 20.5139 30.1873L32.945 17.7012C33.2457 17.3991 33.747 17.3991 34.0477 17.7012C34.4487 18.0033 34.4487 18.5067 34.148 18.8088Z"
									fill="#C5CCDE" />
								<path
									d="M35.5519 22.9383L32.3439 26.1606L33.7474 24.7509C30.4391 28.0738 27.8326 30.6919 24.4241 34.1155C24.1233 34.4176 24.1233 34.921 24.4241 35.2231C24.7248 35.5252 25.2261 35.5252 25.5268 35.2231C31.1408 29.5842 29.3363 31.3967 34.8501 25.8585L33.4466 27.2682L36.6546 24.046C37.3564 23.2404 36.2536 22.1328 35.5519 22.9383Z"
									fill="#C5CCDE" />
								<g filter="url(#filter1_d_3534_264804)">
									<path
										d="M69.0355 14.1763L109.537 54.8571C111.041 56.3675 111.442 58.5828 110.64 60.496C102.519 79.1246 87.7824 93.9268 69.236 102.083C67.3313 102.889 65.1258 102.486 63.622 100.975L23.0205 60.2946C21.5167 58.7842 21.1157 56.5689 21.9177 54.6557C30.1383 36.0271 44.8751 21.225 63.4215 13.0687C65.3263 12.2631 67.5318 12.6659 69.0355 14.1763Z"
										fill="url(#paint0_linear_3534_264804)" />
								</g>
								<path
									d="M78.6598 38.042L46.7801 69.9623C45.8778 70.8685 44.374 70.8685 43.4718 69.9623L30.6397 57.0733C29.7374 56.1671 29.7374 54.6566 30.6397 53.7504L62.5194 21.8301C63.4217 20.9238 64.9254 20.9238 65.8277 21.8301L78.6598 34.719C79.562 35.6253 79.562 37.035 78.6598 38.042Z"
									fill="#0B3275" fill-opacity="0.1" />
								<path
									d="M66.2285 75.0973L58.6094 82.7501C57.9077 83.4549 56.9052 83.4549 56.2034 82.7501L51.1909 77.7153C50.4891 77.0105 50.4891 76.0035 51.1909 75.2987L58.8099 67.6458C59.5117 66.941 60.5142 66.941 61.2159 67.6458L66.2285 72.6806C66.83 73.3854 66.83 74.3924 66.2285 75.0973Z"
									fill="#ECAB03" />
								<path
									d="M65.2285 76.0973L58.6094 82.7501C57.9077 83.4549 56.9052 83.4549 56.2034 82.7501L51.1909 77.7153C50.4891 77.0105 50.4891 76.0035 51.1909 75.2987L57.8099 68.6458C58.5117 67.941 59.5142 67.941 60.2159 68.6458L65.2285 73.6806C65.83 74.3854 65.83 75.3924 65.2285 76.0973Z"
									fill="#F4C563" />
								<path
									d="M78.76 62.4078L71.1409 70.0606C70.4392 70.7655 69.4366 70.7655 68.7349 70.0606L63.7224 65.0259C63.0206 64.321 63.0206 63.3141 63.7224 62.6092L71.3414 54.9564C72.0432 54.2515 73.0457 54.2515 73.7474 54.9564L78.76 59.9911C79.4617 60.696 79.4617 61.8036 78.76 62.4078Z"
									fill="#0B3275" fill-opacity="0.1" />
								<path
									d="M91.291 49.8219L83.6719 57.4747C82.9702 58.1796 81.9677 58.1796 81.2659 57.4747L76.2534 52.4399C75.5516 51.7351 75.5516 50.7281 76.2534 50.0233L83.8724 42.3704C84.5742 41.6656 85.5767 41.6656 86.2784 42.3704L91.291 47.4052C91.9927 48.1101 91.9927 49.117 91.291 49.8219Z"
									fill="#0B3275" fill-opacity="0.1" />
								<path
									d="M76.5545 85.4684L68.9355 93.1212C68.2337 93.826 67.2312 93.826 66.5294 93.1212L61.5169 88.0864C60.8152 87.3816 60.8152 86.3746 61.5169 85.6697L69.136 78.0169C69.8377 77.3121 70.8402 77.3121 71.542 78.0169L76.5545 83.0517C77.156 83.7565 77.156 84.7635 76.5545 85.4684Z"
									fill="#0B3275" fill-opacity="0.1" />
								<path
									d="M89.0854 72.8805L81.4663 80.5333C80.7646 81.2381 79.7621 81.2381 79.0603 80.5333L74.0478 75.4985C73.346 74.7937 73.346 73.7867 74.0478 73.0819L81.6668 65.429C82.3686 64.7242 83.3711 64.7242 84.0729 65.429L89.0854 70.4638C89.7871 71.068 89.7871 72.1756 89.0854 72.8805Z"
									fill="#0B3275" fill-opacity="0.1" />
								<path
									d="M101.717 60.193L94.0979 67.8458C93.3962 68.5506 92.3937 68.5506 91.6919 67.8458L86.6794 62.811C85.9776 62.1062 85.9776 61.0992 86.6794 60.3944L94.2984 52.7415C95.0002 52.0367 96.0027 52.0367 96.7045 52.7415L101.717 57.7763C102.318 58.4812 102.318 59.4881 101.717 60.193Z"
									fill="#0B3275" fill-opacity="0.1" />
								<path
									d="M43.3714 53.1445C43.7724 53.0438 44.1734 53.3459 44.1734 53.7487L44.3739 56.1654H44.4742L45.7774 54.2522C45.9779 53.9501 46.4792 53.8494 46.78 54.1515L46.9805 54.3529C47.2812 54.6549 47.181 55.1584 46.8802 55.3598L44.9754 56.6688V56.7695L47.2812 56.8702C47.6822 56.8702 47.983 57.273 47.8827 57.6758L47.7825 58.0786C47.6822 58.4814 47.2812 58.6827 46.8802 58.4813L44.6747 57.4744L45.6772 59.589C45.8777 59.9918 45.6772 60.3946 45.2762 60.4952L44.9754 60.5959C44.5744 60.6966 44.1734 60.3946 44.1734 59.9918L43.9729 57.5751L42.6697 59.4883C42.4692 59.7904 41.9679 59.8911 41.6672 59.589L41.4667 59.4883C41.1659 59.1862 41.2662 58.6827 41.5669 58.4813L43.3714 57.273L40.9654 57.0716C40.5644 57.0716 40.2637 56.6688 40.3639 56.2661L40.4642 55.8633C40.5644 55.4605 40.9654 55.2591 41.3664 55.4605L43.4717 56.4674L42.4692 54.3529C42.2687 53.9501 42.4692 53.5473 42.8702 53.4466L43.3714 53.1445Z"
									fill="#1C3754" />
								<path
									d="M50.5896 45.9961C50.9906 45.8954 51.3916 46.1975 51.3916 46.6002L51.5921 49.0169H51.6924L52.9956 47.1037C53.1961 46.8016 53.6974 46.7009 53.9981 47.003L54.1986 47.2044C54.4994 47.5065 54.3991 48.01 54.0984 48.2114L52.1936 49.5204V49.6211L54.4994 49.7218C54.9004 49.7218 55.2011 50.1246 55.1009 50.5274L55.0006 50.9301C54.9004 51.3329 54.4994 51.5343 54.0984 51.3329L51.8929 50.326L52.8954 52.4406C53.0959 52.8433 52.8954 53.2461 52.4944 53.3468L52.1936 53.4475C51.7926 53.5482 51.3916 53.2461 51.3916 52.8433L51.1911 50.4267L49.8878 52.3399C49.6873 52.6419 49.1861 52.7426 48.8853 52.4406L48.5846 52.3399C48.2838 52.0378 48.3841 51.5343 48.6848 51.3329L50.4894 50.1246L48.0833 49.9232C47.6823 49.9232 47.3816 49.5204 47.4818 49.1176L47.5821 48.7148C47.6823 48.3121 48.0833 48.1107 48.4843 48.3121L50.5896 49.319L49.5871 47.2044C49.3866 46.8016 49.5871 46.3989 49.9881 46.2982L50.5896 45.9961Z"
									fill="#1C3754" />
								<path
									d="M57.707 38.8457C58.108 38.745 58.509 39.0471 58.509 39.4499L58.7095 41.8665H58.8097L60.113 39.9533C60.3135 39.5506 60.8147 39.5506 61.1155 39.8526L61.316 40.054C61.6167 40.3561 61.6167 40.8596 61.2157 41.061L59.311 42.37V42.4707L61.6167 42.5714C62.0177 42.5714 62.3185 42.9742 62.2183 43.377L62.118 43.679C62.0177 44.0818 61.5165 44.2832 61.2157 44.0818L59.1105 43.0749L60.113 45.1895C60.3135 45.5923 60.113 45.995 59.6117 46.0957L59.311 46.1964C58.91 46.2971 58.509 45.995 58.509 45.5923L58.3085 43.2763L57.0052 45.2902C56.8047 45.5923 56.3035 45.6929 56.0027 45.3909L55.8022 45.1895C55.5015 44.8874 55.5015 44.3839 55.9025 44.1825L57.707 42.9742L55.4012 42.7728C55.0002 42.7728 54.6995 42.37 54.7997 41.9672L54.9 41.6651C55.0002 41.2624 55.5015 41.061 55.8022 41.2624L57.9075 42.2693L56.905 40.1547C56.7045 39.7519 56.905 39.3492 57.306 39.2485L57.707 38.8457Z"
									fill="#1C3754" />
								<path
									d="M65.0256 31.596C65.3263 31.4953 65.7273 31.6967 65.7273 32.0994L65.9278 34.6168H66.0281L67.3313 32.6029C67.5318 32.3008 67.9328 32.3008 68.2336 32.5022L68.6346 32.905C68.8351 33.1064 68.8351 33.6099 68.5343 33.8113L66.5293 35.221V35.3217L68.9353 35.4224C69.3363 35.4224 69.5368 35.8252 69.4366 36.1272L69.2361 36.7314C69.1358 37.0335 68.7348 37.2349 68.4341 37.1342L66.2286 36.1272L67.2311 38.3425C67.3313 38.6446 67.2311 39.0474 66.8301 39.1481L66.3288 39.2488C66.0281 39.3495 65.6271 39.0474 65.6271 38.7453L65.4266 36.2279L64.1233 38.2418C63.9228 38.5439 63.5218 38.5439 63.221 38.3425L62.82 37.9398C62.5193 37.6377 62.6195 37.2349 62.9203 37.0335L64.8251 35.7245L62.3188 35.5231C61.9178 35.5231 61.7173 35.1203 61.8175 34.8182L62.018 34.214C62.1183 33.912 62.5193 33.7106 62.82 33.8113L65.0256 34.8182L64.0231 32.6029C63.9228 32.3008 64.0231 31.8981 64.4241 31.7974L65.0256 31.596Z"
									fill="#1C3754" />
								<defs>
									<filter color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse"
										height="75.9141" id="filter0_d_3534_264804" width="75.6492" x="59.7324"
										y="56.0859">
										<feFlood flood-opacity="0" result="BackgroundImageFix" />
										<feColorMatrix in="SourceAlpha" result="hardAlpha" type="matrix"
											values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
										<feOffset dy="5" />
										<feGaussianBlur stdDeviation="4" />
										<feColorMatrix type="matrix"
											values="0 0 0 0 0.1125 0 0 0 0 0.295916 0 0 0 0 1 0 0 0 0.22 0" />
										<feBlend in2="BackgroundImageFix" mode="normal"
											result="effect1_dropShadow_3534_264804" />
										<feBlend in="SourceGraphic" in2="effect1_dropShadow_3534_264804" mode="normal"
											result="shape" />
									</filter>
									<filter color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse"
										height="123.828" id="filter1_d_3534_264804" width="123.531" x="4.51294"
										y="4.66211">
										<feFlood flood-opacity="0" result="BackgroundImageFix" />
										<feColorMatrix in="SourceAlpha" result="hardAlpha" type="matrix"
											values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
										<feOffset dy="9" />
										<feGaussianBlur stdDeviation="8.5" />
										<feComposite in2="hardAlpha" operator="out" />
										<feColorMatrix type="matrix"
											values="0 0 0 0 0.396078 0 0 0 0 0.478431 0 0 0 0 0.576471 0 0 0 0.25 0" />
										<feBlend in2="BackgroundImageFix" mode="normal"
											result="effect1_dropShadow_3534_264804" />
										<feBlend in="SourceGraphic" in2="effect1_dropShadow_3534_264804" mode="normal"
											result="shape" />
									</filter>
									<linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_3534_264804"
										x1="32" x2="78.5" y1="23" y2="103.5">
										<stop stop-color="#FDFEFF" />
										<stop offset="0.685495" stop-color="#ECF0F5" />
									</linearGradient>
								</defs>
							</svg>
						</div>
					</div>
				</div>
			</div>
		</div>
		<ng-template #defaultImg>
			<img alt="" src="../../../../../assets/images/svgs/empty-state.svg" />
		</ng-template>
	</div>
	<div class="m-t-10">
		<div class="empty-state-text">
			{{ emptyStateText }}
		</div>

		<div class="m-t-8">
			<div (click)="emitEmptyStateFunction.emit()" *ngIf="emptyStateLabel"
				class="empty-state-link-text text-bolder">
				{{ emptyStateLabel }}
			</div>
		</div>
	</div>
</div>